import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import { CircularProgress, Tooltip } from "@material-ui/core";
import CssTextField from "../Utils/CssTextField";
import { InputAdornment } from "@material-ui/core";
import "../styles/routeTable.scss";
import EditRoute from "./editRoute";
import axios from "axios";
import SearchIcon from "@material-ui/icons/Search";
import Pagination from "../../layout/Pagination";
import CustomSelect from "../../NewReport/Components/customSelect";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#fef4f7",
    color: "#000000b3",
    fontSize: 16,
  },
  body: {
    fontSize: 14,
    borderBottom: "1px dashed #362b7338",
    color: "rgb(54 43 115 / 85%)",
    fontWeight: 400,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#00000005",
    },
    borderBottom: "none",
  },
}))(TableRow);

const useStyles = makeStyles({
  tableContainer: { padding: 10, maxHeight: 600, position: "relative" },
  wall: {
    position: "absolute",
    width: "100%",
    height: 10,
    background: "white",
    zIndex: 10,
    top: 0,
  },
  table: {
    minWidth: 700,
    position: "relative",
  },
  chipActive: {
    backgroundColor: "rgba(0, 177, 54, 0.08)",
    color: "rgba(0, 177, 54, 1)",
    width: 69,
    height: 28,
    fontWeight: 500,
    fontSize: 10,
    fontFamily: "Inter",
  },
  chipInactive: {
    backgroundColor: "rgba(238, 50, 53, 0.08)",
    color: "rgba(238, 50, 53, 1)",
    width: 69,
    height: 28,
    fontWeight: 500,
    fontSize: 10,
    fontFamily: "Inter",
  },
  toolBar: {
    marginBottom: 10,
  },
  ToggleButtonGroup: {
    background: "rgba(255, 237, 246, 1)",
  },
  caption: {
    padding: 10,
    fontFamily: "monospace",
    marginTop: 10,
    display: "flex",
  },
  toggleButton: {
    textTransform: "none",
    color: "rgba(245, 54, 137, .93)",
    padding: "5px 11px 5px 11px",
    backgroundColor: "rgba(243, 179, 207, .2)",
    "&.Mui-selected": {
      backgroundColor: "rgba(243, 179, 207, .6)",
      color: "rgba(245, 54, 137, .93)",
      "&:hover": {
        backgroundColor: "rgba(243, 179, 207, .8)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(243, 179, 207, .8)",
    },
  },
});

function RouteTable({
  routeList,
  callBack,
  agencies,
  currentPage,
  currentLimit,
  total,
  onChangeFilterAgency,
  filterAgency,
  searchKey,
  setSearchKey,
  getRouteList,
  setPage,
}) {
  const classes = useStyles();
  const [downloading, setDownloading] = React.useState(null);
  const [search, setSearch] = useState("");

  const downloadMerchantList = (route) => {
    setDownloading(route.id);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/report/${route.id}/outlets`,

        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${route.name}_Merchants.xlsx`);
        document.body.appendChild(link);
        link.click();
        setDownloading(null);
      })

      .catch((err) => {
        console.log(err);
        setDownloading(null);
      });
  };

  return (
    <div>
      <div className="filter-container-route">
        <CssTextField
          variant="outlined"
          placeholder={"Search by Route"}
          value={searchKey}
          style={{ marginRight: 5 }}
          onChange={(e) => {
            e.preventDefault();
            setSearchKey(e.target.value);
          }}
          onKeyDown={(e) => {
            console.log(e);
            if (e.key === "Enter") {
              if (searchKey !== search) {
                setSearch(searchKey);
                if (currentPage === 0) getRouteList();
                setPage("routeTable", 0);
              }
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ opacity: 0.6 }} />
              </InputAdornment>
            ),
          }}
        />
        <button
          className="apply-filter-button"
          disabled={searchKey === search}
          onClick={() => {
            if (currentPage === 0) getRouteList();
            setPage("routeTable", 0);

            setSearch(searchKey);
          }}
        >
          Search
        </button>
        <div className="agency-filter-container">
          <CustomSelect
            item={{
              options: [...agencies],
              label: "Select Distribution House",
            }}
            handleChange={onChangeFilterAgency}
            key={"route-table"}
            isMultiSelect={false}
            onClear={() => onChangeFilterAgency({ target: { value: "" } })}
            style={{ width: 300 }}
          />
          {/* <FormControl variant="filled">
            <InputLabel>Agency</InputLabel>
            <Select
              placeholder="Select an agency"
              style={{ width: 250, height: 50, borderRadius: 50 }}
              value={filterAgency}
              onChange={onChangeFilterAgency}
            >
              {agencies.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          {/* {filterAgency && (
            <p
              className="clear-button"
              onClick={() => onChangeFilterAgency({ target: { value: "" } })}
            >
              Clear
            </p>
          )} */}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <div className={classes.wall}></div>
        <Pagination
          page={"routeTable"}
          currentPage={currentPage}
          total={total}
          limit={currentLimit}
        />

        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table
            stickyHeader={true}
            className={classes.table}
            aria-label="customized table"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell>Route</StyledTableCell>
                <StyledTableCell align="center">Route ID</StyledTableCell>
                {/* <StyledTableCell align="left">Description</StyledTableCell> */}
                <StyledTableCell align="left">Frequency</StyledTableCell>
                <StyledTableCell align="left">Agency</StyledTableCell>
                <StyledTableCell align="left">
                  <div
                    style={{
                      display: "flex",

                      alignItems: "center",
                    }}
                  >
                    {" "}
                    <i
                      className="material-icons left"
                      style={{ marginRight: -1, marginTop: -5 }}
                    >
                      perm_identity
                    </i>
                    Field force
                  </div>
                </StyledTableCell>
                <StyledTableCell align="center">Merchant</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">
                  <p style={{ opacity: 0, margin: 0 }}>Edit</p>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {routeList.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    style={{ color: "#362B73", fontWeight: 500 }}
                  >
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.unique_code === "" ? "-" : row.unique_code}
                  </StyledTableCell>
                  {/* <StyledTableCell align="left">
                    {row.description.length > 0 ? row.description : "-"}
                  </StyledTableCell> */}
                  <StyledTableCell align="left">
                    {row.frequency}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    style={{ fontSize: row.agency.length > 25 ? 10 : 12 }}
                  >
                    {row.agency}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <p
                      className={
                        row.mdo_list.length > 0
                          ? "active-mdo"
                          : "active-mdo disabled"
                      }
                    >
                      {row.mdo_list.length > 0
                        ? row.mdo_list[0]
                        : "Not assigned yet"}
                    </p>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.outlet_count}

                    <Tooltip title="Download merchant list" placement="right">
                      {downloading === row.id ? (
                        <CircularProgress size={12} />
                      ) : (
                        <i
                          className="material-icons right"
                          style={{ marginLeft: 0, cursor: "pointer" }}
                          onClick={() => downloadMerchantList(row)}
                        >
                          download
                        </i>
                      )}
                    </Tooltip>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.is_active ? (
                      <Chip label="Active" className={classes.chipActive} />
                    ) : (
                      <Chip label="Inactive" className={classes.chipInactive} />
                    )}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <EditRoute
                      route={row}
                      callBack={callBack}
                      agencies={agencies}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <span className={classes.caption}>{routeList.length} route(s)</span>
    </div>
  );
}

export default RouteTable;
